import React, { useState } from 'react';
import ownerimg from "../../assets/images/ownerimg.webp";
import owner1 from "../../assets/images/client1.webp";
import owner2 from "../../assets/images/owner2.jpg";
import owner3 from "../../assets/images/client2.jpg";
import ownerbg from "../../assets/images/ownerbg.jpg";


const Ourleaders = () => {
    
    const ownerImages = [
        { img: owner1, text: "As one of Dubai's top MEP contractors, Megavolt is committed to turning your vision into reality. Our team provides exceptional MEP solutions that are both cost-effective and of unmatched quality. Through our expertise and careful project assessment,",name:"Jamshadpal",place:"India, Punjab" },
        { img: owner2, text: "We are a leading MEP company in the UAE, known for delivering exceptional technical services. Our reliable, efficient, and budget-friendly solutions make us a preferred",name:"mohammad",place:"Dubae, abudhabi" },
        { img: owner3, text: "Megavolt has successfully executed multiple electrical, construction, HVAC, and MEP projects, consistently designing and completing them to meet the highest safety and quality standards",name:"riswan",place:"Australia, Sydney" },
      ];
      const [selectedIndex, setSelectedIndex] = useState(0); // Default to first image
  return (
    <div>
    
        <div className="relative bg-no-repeat bg-cover md:h-[100vh] flex items-center justify-center py-10 px-3" style={{ backgroundImage: `url(${ownerbg})` }}>
<div className="absolute inset-0 bg-black opacity-50"></div>
<div className="relative container mx-auto">
  <div className="">
    <h1 className=' text-orange my-2 sm:my-3  text-2xl text-center'> Our Leaders</h1>
    <div className="text-center">
      <p className="italic text-white md:text-2xl text-lg text-center">{ownerImages[selectedIndex].text}</p>
      <p className="mt-3 text-white text-center text-xl"><span className="mr-2 text-orange font-bold">{ownerImages[selectedIndex].name}</span>{ownerImages[selectedIndex].place}</p>
    </div>
    <div className="md:mt-32 mt-20">
      <div className="flex items-center justify-center md:gap-7 gap-3">
        {ownerImages.map((item, index) => (
          <div
            key={index}
            className={`border-2 rounded-full cursor-pointer hover:scale-105 transition-transform duration-300 
              ${selectedIndex === index ? 'border-orange' : 'border-transparent'}`}
            onClick={() => setSelectedIndex(index)} // Update selected index on click
          >
            <img
              src={item.img}
              alt={`Owner ${index + 1}`}
              className="w-[100px] h-[100px] rounded-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  </div>
</div>
</div>



  
    </div>
  )
}

export default Ourleaders